import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { type LoginResponse, Routes } from '@tg-leads/contracts';

import { api, ApiError, setToken } from '../lib/api';

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('admin@local.test');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: () =>
      api.post<LoginResponse>(Routes.auth.login, { email, password }),
    onSuccess: (data) => {
      setToken(data.token);
      navigate('/admin/proxies', { replace: true });
    },
    onError: (e: unknown) => {
      if (e instanceof ApiError) {
        if (e.status === 429) setErr('登录尝试过于频繁，15 分钟后再试');
        else if (e.status === 401) setErr('邮箱或密码不正确');
        else setErr(e.message);
      } else {
        setErr(String(e));
      }
    },
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    mutation.mutate();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <form onSubmit={onSubmit} className="card w-96 space-y-4">
        <div>
          <h1 className="text-xl font-semibold">TG Leads · 登录</h1>
          <p className="text-sm text-slate-500 mt-1">销售员 / 管理员入口</p>
        </div>
        <div>
          <label className="label">邮箱</label>
          <input
            type="email"
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={mutation.isPending}
          />
        </div>
        <div>
          <label className="label">密码</label>
          <input
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            disabled={mutation.isPending}
          />
        </div>
        {err && (
          <div className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded">
            {err}
          </div>
        )}
        <button
          type="submit"
          className="btn-primary w-full"
          disabled={mutation.isPending}
        >
          {mutation.isPending ? '登录中…' : '登录'}
        </button>
        <p className="text-xs text-slate-400 pt-2">
          开发默认账号 admin@local.test / admin123（生产环境务必换强密码）
        </p>
      </form>
    </div>
  );
}
